export enum SignalRActionNamesEnum {
  UnlockConnector,
  StatusNotification,
  RemoteStartTransaction,
  RemoteStopTransaction,
  MeterValues,
  BootNotification,
  Reset,
  OcppMessage
}

export enum CallMessageTypesEnum {
  CallMessage,
  CallResultMessage
}
export enum AuthorizationStatusEnum {
  Accepted,
  Blocked,
  Expired,
  Invalid,
  ConcurrentTx
}
export enum UnlockConnectorStatusEnum {
  Accepted,
  Unlocked,
  UnlockFailed,
  NotSupported
}


export enum ResetCPEnum {
  Accepted,
  Rejected,
}



export enum StatusNotificationEnum {
  Available = 1,
  Preparing = 2,
  Charging = 3,
  SuspendedEVSE = 4,
  SuspendedEV = 5,
  Finishing = 6,
  Reserved = 7,
  Unavailable = 8,
  Faulted = 9

}
export enum ChangeAvailabilityTypes {
  Operative,
  Inoperative
}
